import { getCurrentEnvironment } from '@telstra-connect/config/config';
import { flagIsSet } from '@telstra-connect/feature-flags';
import { IFeatureFlags } from './common';
import flagsData from './flags';

let featureFlags: IFeatureFlags;

export const loadFeatureFlags = (): void => {
    const environment = getCurrentEnvironment();
    featureFlags = Object.freeze({
        application: flagIsSet(flagsData.application, environment),
        buttonIntegrations: flagIsSet(flagsData.buttonIntegrations, environment)
    });
};

export const getTPAMSReportsFlags = (): IFeatureFlags => {
    loadFeatureFlags();
    return featureFlags;
};
